import React, { useState } from "react";
import AcordeonText from "./acordeonText/acordeon";
import AcordeonList from "./acordeonList/acordeon";
import AcordeonListTwo from "./acordeonList/acordeonListTwo";
import TitleCard from "./texts/titleCard";
import Title from "./texts/headline";
import Body from "./texts/body";
import "./accordeon.css";

const Accordeon = () => {
  const dataAccordeon = [
    {
      Titulo: "Corporate Tax Service",
      Texto: [
        "Tax consulting service",
        "Perennial tax adviser",
        "Tax services for M&A",
        "Tax planning scheme design",
        "Tax refund for export",
        "Invoice agency service (invoices issued by designated tax authorities)",
        "Business registration, change, cancellation services",
        "Tax compliance and tax filing services",
        "Tax training service",
      ],
    },
    {
      Titulo: "Tax-related risk control",
      Texto: [
        "Tax-related risk identification and diagnosis",
        "Tax-related investigation service",
        "Corporate tax dispute service",
        "Enterprise tax risk control of the whole process",
      ],
    },
    {
      Titulo: "Tax compliance audit",
      Texto: [
        "Review of corporate income tax returns for final settlement",
        "Filing and examination of various tax incentives",
        "hoTax audit of IPO projectsla",
        "Enterprise tax write-off liquidation review",
        "Other tax compliance audit service",
      ],
    },
    {
      Titulo: "Cross-Broader Tax Consulting",
      Texto: [
        "Overseas listing tax audit",
        "Tax treaty consultation",
        "International tax compliance and reporting services",
        "International mergers and acquisitions",
        "Global trade tax services",
        "Tax plan for overseas accounts",
        "Tax consultation and related services for foreign-funded enterprises",
        "Foreign individual tax consultation and related services",
      ],
    },
    {
      Titulo: "Transfer pricing",
      Texto: [
        "Transfer pricing declaration",
        "Transfer pricing advisory",
        "Preparation of contemporaneous data",
        "APA",
        "TP-related investigation service",
        "Other transfer pricing services ",
        "Transfer pricing consultation and period data preparation",
        "(APA) Dispute avoidance: Advance pricing agreements",
        "(MAP/CA) Dispute resolution: Examination defense and mutual agreement procedure/competent authority",
      ],
    },
    {
      Titulo: "Tax transaction support",
      Texto: [
        "Tax support for capital operations",
        "Tax due diligence",
        "Tax-related services for import and export",
        "Foreign transaction support",
      ],
    },
    {
      Titulo: "Personal tax services",
      Texto: [
        "Personal income tax filing agent service",
        "Personal income tax deferred tax application agent service",
        "Personal income tax planning service",
      ],
    },
  ];
  const dataAccordeonDos = [
    {
      Titulo: "Finance and Accounting",
      Texto: [
        "Financial structure designing and risk control",
        "Sophisticated accounting treatment consulting",
        "Accounting technical support",
        "Bookkeeping agency service (bilingual)",
      ],
    },
    {
      Titulo: "M&A services",
      Texto: [
        "Financial and tax due diligence",
        "Accounting advice on sale and purchase agreement",
        "Seller's due diligence/assistance",
      ],
    },
    {
      Titulo: "Project consulting service",
      Texto: [
        "IPO listing feasibility assessment",
        "IPO overseas listing report and report language conversion service",
        "Transaction consulting",
        "M&A  support",
      ],
    },
  ];
  const dataAccordeonTres = [
    {
      Titulo: "The government reach-out service",
      Texto: [
        "Application according to the policy",
        "Consultation with local governments in assistance of application for the preferential policy",
        "Governmental financial support  agency service",
      ],
    },
    {
      Titulo: "The proxy service",
      Texto: [
        "Tax relief service for tax difficulties",
        "Business and tax services",
        "Foreign exchange servicee",
        "Various tax preference application and filing services",
        "High-tech agency service"
      ],
    },
    
  ];
  return (
    <>
      <div className="content_faqs">
        <div className="FAQsBox">
          <div className="accordeonTitleContainer">
            <div className="acordeonDivider"></div>
            <TitleCard value="Tax advisory" styleClass="accordeonTitle" />
            <div className="acordeonDivider"></div>
          </div>
          <div className="boxFaqsAcordeon">
            <AcordeonText valor={dataAccordeon} />
          </div>
        </div>
        <div className="FAQsBox">
          <div className="accordeonTitleContainer">
            <div className="acordeonDivider"></div>
            <TitleCard
              value="Financial
services"
              styleClass="accordeonTitle"
            />
            <div className="acordeonDivider"></div>
          </div>
          <div className="boxFaqsAcordeon">
            <AcordeonText valor={dataAccordeonDos} />
          </div>
        </div>
        <div className="FAQsBox">
          <div className="accordeonTitleContainer">
            <div className="acordeonDivider"></div>
            <TitleCard
              value="Other
compliance
services"
              styleClass="accordeonTitle"
            />
            <div className="acordeonDivider"></div>
          </div>
          <div className="boxFaqsAcordeon">
            <AcordeonText valor={dataAccordeonTres} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Accordeon;
